export function formatNullStringNumberToString(item: string | null | number) {
  if (item === null) {
    return ''
  }
  return `${item}`
}